import React, { useState } from 'react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { isValidArray } from '../../../utils/is-array';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Chip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { INSPECTION_REPORT_TYPE, NUMBER, PAINT_IMAGE_LABEL } from '../../../constants/app-constants';
import LazyLoadCarouselItems from './lazy-load-carousel-items';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

import 'swiper/css';
import 'swiper/css/pagination';
import ReactPlayer from 'react-player';
import CustomToolTip from '../tooltip';
const Carousel = ({ pai, settings = {}, zoom, thumbsSettings, isGallery = false, items, code, height = NUMBER.TWO_HUNDRED, width = NUMBER.TWO_HUNDRED_AND_SEVENTY, addThumbnailPadding = true, handleImageClick = () => { } }) => {
    const [showInfo, setShowInfo] = useState(false);
    const [isZoomedIn, setIsZoomedIn] = useState(false);

    const carouselSettings = {
        spaceBetween: 2,
        slidesPerView: 1.3,
        ...settings,
    };

    const handleInfoClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };

    const handlePinch = (ref) => {
        const { scale } = ref && ref.state;
        if (!isZoomedIn && scale > 1) {
            setIsZoomedIn(true);
        } else {
            setIsZoomedIn(false);
        }
    };

    return (
        <div className='relative'>
            {pai && <span onClick={handleInfoClick} className={`absolute flex items-center justify-between gap-1 top-0 bg-success z-10 text-white pl-3 pr-1.5 py-1 text-sm font-bold ${!isGallery ? 'rounded-br-xl' : ''}`}>EXCLUSIVE
                <CustomToolTip handleClose={setShowInfo.bind(null, false)} open={showInfo}>
                    <InfoOutlinedIcon onClick={setShowInfo.bind(null, true)} />
                </CustomToolTip>
            </span>}
            <Swiper
                {...carouselSettings} className='text-light-border'
            >
                {isValidArray(items) && items.map((item, index) => (
                    <SwiperSlide key={index} className={`${index + 1 !== items.length && carouselSettings?.slidesPerView > 1 && 'text-border'}`}>
                        <Stack direction={'row'} sx={{ display: 'flex!important' }} className={`relative bg-text`}>
                            <LazyLoadComponent>
                                <LazyLoadCarouselItems
                                    component={item?.mediaType === INSPECTION_REPORT_TYPE.VIDEO ? 'video' : 'img'}
                                    controls={item?.mediaType === INSPECTION_REPORT_TYPE.VIDEO}
                                    maintainAspectRatio={isGallery}
                                    height={height}
                                    zoom={zoom}
                                    isSummaryImage={item?.label === PAINT_IMAGE_LABEL}
                                    width={width}
                                    image={`${item?.url}?auto=format${!isGallery ? '&width=0.6' : ''}`}
                                    alt={item?.category}
                                    onClick={handleImageClick.bind(null, { ...item, index, total: items?.length })}
                                    disabblePanning={!isZoomedIn}
                                    handlePinch={handlePinch}
                                />
                            </LazyLoadComponent>
                            {code && <Chip label={code} className='absolute bottom-3 left-0 h-8 bg-border rounded' size='large' classes={{ label: 'text-white text-lg font-bold' }} />}
                        </Stack>
                    </SwiperSlide>
                ))}
                {!isValidArray(items) && <div style={{ minHeight: '200px' }} className='bg-border' />}
            </Swiper>
            {
                thumbsSettings && <Swiper style={{ padding: `${addThumbnailPadding ? '1rem' : '0.2rem'}`, paddingBottom: `${isValidArray(items) && items?.length > 3 && addThumbnailPadding ? '2rem' : '0'}` }}
                    {...thumbsSettings} className='bg-background text-light-border'
                >
                    {isValidArray(items) && items.map((item, index) => (
                        <SwiperSlide key={index} className={`${index + 1 !== items.length && carouselSettings?.slidesPerView > 1 && 'text-border'}`}>
                            <Stack direction={'row'} sx={{ display: 'flex!important' }} className={`relative bg-text rounded-md`}>
                                {item?.mediaType !== INSPECTION_REPORT_TYPE.VIDEO &&
                                    <LazyLoadComponent>
                                        <LazyLoadCarouselItems
                                            component={'img'}
                                            height={60}
                                            width={125}
                                            className="rounded-md"
                                            image={`${item?.url}?auto=format&format=pjpg&width=0.2`}
                                            alt={item?.category}
                                        />
                                    </LazyLoadComponent>}
                                {item?.mediaType === INSPECTION_REPORT_TYPE.VIDEO && <ReactPlayer url={item.url} light={true} playing={false} height={75}
                                    width={125} />}
                            </Stack>
                        </SwiperSlide>
                    ))}
                </Swiper>
            }
        </div >
    );
};

Carousel.propTypes = {
    pai: PropTypes.bool,
    isGallery: PropTypes.bool,
    isPartialGallery: PropTypes.bool,
    zoom: PropTypes.bool,
    settings: PropTypes.object,
    items: PropTypes.array,
    code: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    handleImageClick: PropTypes.func,
    thumbsSettings: PropTypes.object,
    addThumbnailPadding: PropTypes.bool
};

export default Carousel;
